import { useState, useEffect, useCallback, useRef } from "react";
import { T, API, Icon } from "../AdminPanel";
import { useApi } from "../AdminPanel";

export default function HeroEditorPage({ token, toast, onExpired }) {
  const { get, del, patch, upload } = useApi(token, onExpired);
  const fileRef = useRef();
  const [images, setImages]       = useState([]);
  const [loading, setLoading]     = useState(true);
  const [uploading, setUploading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await get("/images/?section=hero");
      setImages([...data].sort((a, b) => a.sort_order - b.sort_order));
    } catch (e) {
      if (e.message !== "SESSION_EXPIRED") toast("Ошибка загрузки", "error");
    } finally {
      setLoading(false);
    }
  }, [get, toast]);

  useEffect(() => { load(); }, [load]);

  const handleUpload = async (files) => {
    setUploading(true);
    for (const file of Array.from(files)) {
      const fd = new FormData();
      fd.append("file",       file);
      fd.append("section",    "hero");
      fd.append("title",      "Hero фото");
      fd.append("sort_order", String(images.length));
      try   { await upload("/images/upload", fd); }
      catch { toast("Ошибка загрузки", "error"); }
    }
    setUploading(false);
    toast("Загружено", "success");
    load();
  };

  const handleDelete = async (id) => {
    try {
      await del(`/images/${id}`);
      toast("Удалено", "success");
      setImages(prev => prev.filter(i => i.id !== id));
    } catch { toast("Ошибка", "error"); }
  };

  const moveUp = async (idx) => {
    if (idx === 0) return;
    const a = images[idx], b = images[idx - 1];
    await Promise.all([
      patch(`/images/${a.id}/meta`, { sort_order: b.sort_order }),
      patch(`/images/${b.id}/meta`, { sort_order: a.sort_order }),
    ]);
    load();
  };

  const moveDown = async (idx) => {
    if (idx === images.length - 1) return;
    const a = images[idx], b = images[idx + 1];
    await Promise.all([
      patch(`/images/${a.id}/meta`, { sort_order: b.sort_order }),
      patch(`/images/${b.id}/meta`, { sort_order: a.sort_order }),
    ]);
    load();
  };

  return (
    <div>
      <div className="adm-eyebrow">Hero-секция</div>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 28 }}>
        <h1 style={{ fontFamily: "'Oswald',sans-serif", fontSize: 32, fontWeight: 400, textTransform: "uppercase", letterSpacing: "0.04em" }}>
          Главный экран
        </h1>
        <div style={{ display: "flex", gap: 8 }}>
          <input ref={fileRef} type="file" accept="image/*" multiple style={{ display: "none" }}
            onChange={e => handleUpload(e.target.files)} />
          <button className="adm-btn adm-btn--primary" onClick={() => fileRef.current.click()} disabled={uploading}>
            {Icon.Upload} {uploading ? "Загрузка..." : "Добавить фото"}
          </button>
          <button className="adm-btn" onClick={load}>{Icon.Refresh} Обновить</button>
        </div>
      </div>

      {images.length > 1 && (
        <div style={{ marginBottom: 16, padding: "10px 14px", background: "rgba(16,201,165,0.08)", border: "1px solid rgba(16,201,165,0.2)", fontSize: 13, color: T.textMuted }}>
          {Icon.Check} При наличии нескольких фото на сайте активируется автоматическая смена слайдов (каждые 5 сек)
        </div>
      )}

      {loading ? (
        <div className="adm-empty"><span className="adm-spinner" /></div>
      ) : images.length === 0 ? (
        <div className="adm-empty">Нет фото для главного экрана. Загрузите первое.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {images.map((img, idx) => (
            <div key={img.id} style={{ display: "grid", gridTemplateColumns: "120px 1fr auto", gap: 12, alignItems: "center", background: T.white, border: `1px solid ${T.border}`, padding: "12px 16px" }}>
              <img src={`${API}/images/${img.id}/file`} alt={img.title}
                style={{ width: 120, height: 72, objectFit: "cover" }} />
              <div>
                <div style={{ fontWeight: 500, fontSize: 13 }}>{img.title || img.filename}</div>
                <div style={{ fontSize: 11, color: T.textHint, marginTop: 2 }}>Порядок: {idx + 1}</div>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="adm-btn adm-btn--sm" onClick={() => moveUp(idx)}   disabled={idx === 0}>↑</button>
                <button className="adm-btn adm-btn--sm" onClick={() => moveDown(idx)} disabled={idx === images.length - 1}>↓</button>
                <button className="adm-btn adm-btn--sm adm-btn--danger" onClick={() => handleDelete(img.id)}>{Icon.Trash}</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}